import React from 'react';
import styles from '../../../TopNavBar.module.scss';
import Spinner from 'shared/components/andtComponents/Spinner';
import { palette } from 'shared/constants/colorsConstants.js';
import { Currency } from 'shared/components/CurrencySelect/types';

interface FeatureNotActivated {
  selectedCurrency: Currency | null;
}

export const FeatureNotActivated: React.FC<FeatureNotActivated> = ({
  selectedCurrency,
}: FeatureNotActivated): React.ReactNode => {
  return (
    <div className={styles.roundButton}>
      {selectedCurrency ? (
        <span>
          {selectedCurrency?.code} ({selectedCurrency?.symbolNative})
        </span>
      ) : (
        <Spinner position="relative" size={20} color={palette.blue[500]} />
      )}
    </div>
  );
};
